export const isShopifyAccountCAD = marketAccount =>
  (marketAccount && marketAccount.meta && marketAccount.meta.currency === 'CAD') || false
